import React from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  Grid,
  Paper,
  Stack,
} from "@mui/material";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import InsightsIcon from "@mui/icons-material/Insights";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AppBarMain from "../../common/navigation-bars/AppBarMain";

const LandingPage = () => {
  return (
    <AppBarMain noPadding={true} isUserLoggedIn={false}>
      <Box sx={{ bgcolor: "#f4f6f8", minHeight: "93vh", width: "100%" }}>
          <Box 
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/images/LandingBg.svg)`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              color: "#fff",
            }}
            className="landing-background-img">
              <Grid container spacing={6} sx={{ p: 4, alignItems: "center" }}>
                <Grid item xs={12} md={6} mt={7} ml={7}>
                  <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: "bold" }}>
                    Transform Documents <br /> Into Data-Driven Decisions
                  </Typography>
                  <Typography variant="h6" className="color-light-gray">
                    Use smart document processing to unlock insights hidden in your documents. From scanning to strategy—make every word count.
                  </Typography>
                </Grid>
              </Grid>
          </Box>
          <Box sx={{ mt: 2, width: "100%", textAlign: "center" }} >
            <Typography variant="h4" align="center" gutterBottom>
              What You Can Do
            </Typography>
            <Grid container spacing={2} mt={2} className="display-center">
              <Grid item xs={12} md={3}>
                <Paper sx={{ p: 4, textAlign: "center", borderRadius: 3 }}>
                  <DocumentScannerIcon sx={{ fontSize: 50, color: "#1976d2" }} />
                  <Typography variant="h6" sx={{ mt: 2 }}>
                    Extract Information
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Scan and digitize documents with high accuracy using AI.
                  </Typography>
                </Paper>
              </Grid>

              <Grid item xs={12} md={3}>
                <Paper sx={{ p: 4, textAlign: "center", borderRadius: 3 }}>
                  <InsightsIcon sx={{ fontSize: 50, color: "#1976d2" }} />
                  <Typography variant="h6" sx={{ mt: 2 }}>
                    Analyze Smartly
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Automatically detect trends, entities, and key metrics.
                  </Typography>
                </Paper>
              </Grid>

              <Grid item xs={12} md={3}>
                <Paper sx={{ p: 4, textAlign: "center", borderRadius: 3 }}>
                  <TrendingUpIcon sx={{ fontSize: 50, color: "#1976d2" }} />
                  <Typography variant="h6" sx={{ mt: 2 }}>
                    Make Better Decisions
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Empower your team to act faster with confident decisions.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Box>
      </Box>
    </AppBarMain>
  );
};

export default LandingPage;
